<template>
  <div class="ucar-val" :class="{'disabled': disabled}">
    <div class="ucar-val-block" @click="clickHandler">{{name}}</div>
  </div>
</template>


<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clickHandler () {
      this.$emit('click')
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "../styles/variable.styl";

.ucar-val {
  flex: 1 0 0;
  display: inline-block;
  height: 100%;
  position: relative;
  font-size: $ucar_font_h4;
  line-height: 100px;
  text-align: right;
  padding-right: 40px;
  height: 100%;
  color: $ucar_font_color;

  &::after {
    position: absolute;
    right: 5px;
    top: 50%;
    content: "";
    display: inline-block;
    width: 16px;
    height: 16px;
    border-bottom: 2px solid $ucar_font_assist_color;
    border-right: 2px solid $ucar_font_assist_color;
    transform: translate3d(0, -50%, 0) rotate(-45deg);
    box-sizing: border-box;
  }

  &.disabled {
    pointer-events: none;
  }

  &.disabled::after {
    display: none;  
  }
}
</style>